import { $qs, $qsa } from '@js/utils/querySelector'; 

function addRainbowElements(button) {
    const rainbowSpan = document.createElement('span');
    rainbowSpan.classList.add('colours');

    const colors = ['yellow', 'red', 'teal'];
    colors.forEach(color => {
        const colorSpan = document.createElement('span');
        colorSpan.classList.add(color);
        rainbowSpan.appendChild(colorSpan);
    });

    button.appendChild(rainbowSpan);
}

function buttons() {
    const buttons = $qsa('.button');

    if (!buttons.length) return;

    [...buttons].forEach((button) => {
        addRainbowElements(button);
    });
}

export default buttons;
